export class SearchCondition {
  curriculum_id: string = ""
  name: string = ""
  event_code: string = ""
}

export class Curriculum {
  id: number
  name: string
  event_codes: string
  sort_no: number

  constructor(x: any){
    this.id = x.id;
    this.name = x.name;
    this.event_codes = x.event_codes;
    this.sort_no = x.sort_no;
  }
}